import {OverlayContainer} from "../../../misc/ImageViewer";
import React, {useRef, useState} from "react";
import SchemaEditContainer from "../SchemaEditContainer";
import {SqlQuery} from "../BackTableFieldViewTable";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {
    BackOuterField, BackPermaFilter,
    BackTableField,
    setBackTableField,
    setBackTableOuterField, setBackTablePermaField
} from "../../../../features/schemaManageSlice";
import styled from "styled-components";


type PropsI = {
    closeEditing: () => void,
    addNew?: boolean,
    filterKey: string,
    filter: BackPermaFilter,
};
export default function EditPermaFilter({closeEditing, addNew = false, filterKey, filter}: PropsI) {
    const tableName = useAppSelector(state => state.schemaManage.back.selectedTable) as string;
    const table = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const [newValue, setNewValue] = useState(filter)
    const [name, setName] = useState(filterKey)
    const selectDepRef = useRef<HTMLSelectElement | null>(null);
    const dispatch = useAppDispatch();
    const deleteFilterDep = (dep: string) => setNewValue(prevState => ({
        ...prevState,
        depends: prevState.depends!.filter(j => j !== dep)
    }));

    const addFilterDep = (dep: string) => setNewValue(prevState => ({
        ...prevState,
        depends: prevState.depends ? Array.from(new Set(prevState.depends.concat(dep))) : [dep]
    }));


    return <OverlayContainer $isVisible>
        <SchemaEditContainer>
            <Container>
                <div>{addNew ? "Створити" :"Редагувати"} постійний фільтр {name}</div>
                {addNew && <div>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)}/>
                </div>}
                {newValue.sql && <div>
                    <SqlQuery sqlQuery={newValue.sql}/>
                </div>}


                <div>
                    <div>Нове значення:</div>
                    <div className="new-text-area">
                        <textarea name="newSql" id="newSql" rows={4} value={newValue.sql?.toString()}
                                  onChange={(e) => setNewValue(prevState => ({
                                      ...prevState,
                                      sql: e.target.value
                                  }))}></textarea>
                    </div>
                </div>

                {newValue.depends.length > 0 && <div>
                    <div>Поля що залежать від цього ПОСТІЙНОГО фільтра:</div>
                    <div className="all-deps">
                        {newValue.depends.map((f, i) => {
                            let e = null;

                            // if (table.fieldsList[f] && table.fieldsList[f].sqlQuery)
                            //     e = <SqlQuery key={i} sqlQuery={table.fieldsList[f].sqlQuery!}/>
                            if (table.fieldsList[f])
                                e = <span className={'dep'}>{f}</span>
                            else
                                e = <span className={'dep'}>ТАКОГО ПОЛЯ НЕ ІСНУЄ</span>

                            return <div className={'outer-dep'} key={i}>
                                <div className="dep-view">
                                    {e}
                                </div>
                                <button className="del-dep btn-cmn" onClick={() => deleteFilterDep(f)}>
                                    ❌
                                </button>
                            </div>
                        })}
                    </div>

                </div>}
                {Object.keys(table.fieldsList).length > newValue.depends.length &&
                    <div className="edit-field-dep-add">
                        <div>
                            Додати нове залежне поле:
                        </div>
                        <div className={'sel'}>
                            <select name="deps" id="deps" ref={selectDepRef}>
                                {Object.keys(table.fieldsList).filter(k => !newValue.depends.includes(k))
                                    .map(k => <option value={k} key={k}>{k}</option>)}
                            </select>
                            <button className={'btn-cmn'}
                                    onClick={() => addFilterDep(selectDepRef.current?.value!)}>Додати
                            </button>
                        </div>
                    </div>
                }


                <div className={'controls'}>
                    {!addNew && <div className="delete">
                        <button className={'btn-cmn'} onClick={() => {
                            dispatch(setBackTablePermaField({
                                table: tableName,
                                fieldKey: filterKey,
                                value: undefined
                            }))
                            closeEditing()
                        }}>
                            Видалити це фільтр
                        </button>
                    </div>}
                    <button className={'save btn-cmn'} onClick={() => {
                        if (addNew && ethereal && ethereal.permaFilter[name]) {
                            alert("Фільтр з таким ключем вже є! Змініть ключ")
                            return
                        }
                        dispatch(setBackTablePermaField({
                            table: tableName,
                            fieldKey: name,
                            value: newValue
                        }))
                        closeEditing()
                    }}>
                        Зберегти
                    </button>
                    <button className="close btn-cmn" onClick={closeEditing}>
                        ❌
                    </button>
                </div>
            </Container>
        </SchemaEditContainer>
    </OverlayContainer>

}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: .5rem;

  .delete-field {
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;
    align-items: center;
  }
  
  .all-deps {
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;
    max-width: 700px;
  }

  .outer-dep {
    display: flex;
    gap: .2rem;
    align-items: center;
    flex-wrap: wrap;

    .dep {
      padding: .2rem .4rem;
      border-radius: .2rem;
      background-color: black;
      color: white;
    }
  }

  .edit-field-dep-add {
    display: flex;
    flex-flow: column;
    gap: .5rem;

    .sel {
      display: flex;
      gap: .5rem;
    }
  }
`
